import SearchData from './dashboard/search';

export default function DiscoverInfluencer() {
  return <SearchData/>;
}
